/** Cache de layouts calculados pelo ELK (módulo leve, sem importar o ELK). */
export const LAYOUT_CACHE = new Map<string, unknown>();
export const clearLayoutCache = () => LAYOUT_CACHE.clear();
